import * as Sentry from '@sentry/react';
import type { GemaRequestError, RequestPhase } from './requestError';
export type ExperienceOrigin = 'initial' | 'manual' | 'focus' | 'online' | 'visibility' | 'interval' | 'automatic';
export function startExperienceAttempt(origin: ExperienceOrigin, attempt: number) {
  const started = performance.now();
  let phase: RequestPhase = 'session';
  let phaseStarted = started;
  const durations: Partial<Record<RequestPhase, number>> = {};
  let span: ReturnType<typeof Sentry.startInactiveSpan> | null = null;
  try {
    if (Sentry.getClient()) span = Sentry.startInactiveSpan({ name: 'gema.experience', op: 'ui.load', forceTransaction: true });
  } catch { /* SDK failure must not block the lookup. */ }
  const tick = () => { const now = performance.now(); durations[phase] = (durations[phase] ?? 0) + now - phaseStarted; phaseStarted = now; };
  return {
    phase(next: RequestPhase) { tick(); phase = next; },
    end(error?: GemaRequestError, reportFailure = false) {
      tick();
      const data = {
        'gema.origin': origin, 'gema.attempt': attempt,
        'gema.outcome': error ? error.kind === 'cancelled' ? 'cancelled' : 'error' : 'ok',
        'gema.phase': error?.phase ?? phase, 'gema.error_kind': error?.kind ?? 'none',
        'gema.http_status': error?.status ?? 0,
        'gema.duration_ms': Math.round(performance.now() - started),
        'gema.session_ms': Math.round(durations.session ?? 0),
        'gema.fetch_ms': Math.round(durations.fetch ?? 0),
        'gema.body_ms': Math.round(durations.body ?? 0),
      };
      try {
        span?.setAttributes(data); span?.setStatus({ code: error ? 2 : 1 }); span?.end();
        // One failure event per mounted account, not one Issue per 60s poll.
        if (reportFailure) Sentry.captureMessage('Gema experience lookup failed', { level: 'warning', fingerprint: ['gema-experience-lookup'], extra: data });
      } catch { /* Diagnostics must never change availability or retry behavior. */ }
    },
  };
}
